<template>
    <template v-if="shouldShowMainScreen">
        <Teleport to=".view.services > .head">
            <div class="table-allocation-label-container" v-if="identity.hasOperatorAccess" @click="onClick">
                <TableNameLabel />
            </div>
        </Teleport>
    </template>

    <template v-if="shouldShowOffer">
        <Teleport to=".view.order > .head">
            <div class="table-allocation-label-container" v-if="identity.hasOperatorAccess" @click="onClick">
                <TableNameLabel />
            </div>
        </Teleport>
    </template>

    <template v-if="shouldShowPreorder">
        <Teleport to=".view.preorder-time > .head">
            <div class="table-allocation-label-container" v-if="identity.hasOperatorAccess" @click="onClick">
                <TableNameLabel />
            </div>
        </Teleport>
    </template>

    <template v-if="shouldShowPay">
        <Teleport to=".view.bill > .head">
            <div class="table-allocation-label-container" v-if="identity.hasOperatorAccess" @click="onClick">
                <TableNameLabel />
            </div>
        </Teleport>
    </template>

    <template v-if="shouldShowOpenBills">
        <Teleport to=".view.open-bills > .head">
            <div
                class="table-allocation-label-container"
                v-if="identity.hasOperatorAccess"
                @click="openTableSelectionPopover"
            >
                <TableNameLabel />
            </div>
        </Teleport>
    </template>
</template>

<script setup lang="ts">
    // this components works as a wrapper for the TableNameLabel component
    // it is used to teleport the TableNameLabel component to the correct place in the DOM
    // this is a solution to use Vue Components in vanilla TS files
    import { appEvents as globalAppEvents } from "@/app/App";
    import { appEvents } from "@/app/events/appEvents";
    import { TableSelectionPopover } from "@/app/popover/TableSelectionPopover";
    import { useIdentityStore } from "@/data/stores/identity";
    import { useTableAllocationStore } from "@/data/stores/tableAllocation";
    import { nextTick, ref } from "vue";

    import TableNameLabel from "@/components/tableAllocation/TableNameLabel.vue";

    const identity = useIdentityStore();
    const allocation = useTableAllocationStore();

    function openTableSelectionPopover() {
        new TableSelectionPopover(allocation.locationId!, allocation.allocation?.locationName!).show();
    }

    function onClick() {
        // show open bills controller
        globalAppEvents.OnShowOpenBills.dispatch();

        // open table selection popover
        openTableSelectionPopover();
    }

    // hack: this is a workaround to make sure the button is shown when the view is shown
    const shouldShowMainScreen = ref(false);
    const shouldShowOffer = ref(false);
    const shouldShowPay = ref(false);
    const shouldShowOpenBills = ref(false);
    const shouldShowPreorder = ref(false);

    appEvents.controller.shown.add(async () => {
        await nextTick();
        shouldShowMainScreen.value = $(".view.services.shown").length > 0;
        shouldShowOffer.value = $(".view.order.shown").length > 0;
        shouldShowPay.value = $(".view.bill.shown").length > 0;
        shouldShowOpenBills.value = $(".view.open-bills.shown").length > 0;
        shouldShowPreorder.value = $(".view.preorder-time.shown").length > 0;
    });
</script>

<style lang="scss">
    .table-allocation-label-container {
        display: inline-block;

        position: absolute;
        padding-top: 9px;
        top: 0;
        left: 52px;
        height: 43px;
    }

    .view.services .table-allocation-label-container {
        left: 20px;
    }
</style>
